export class RawMaterialGrade{
    rawMaterialGradeId?: number;
    rawMaterialGradeCode?:string;
    isDefault?: boolean;
    isDummy?: boolean;
}
 
export class RawMaterialGrades{
    rawMaterialGrades?: RawMaterialGrade[];
}

export class RawMaterialGradesForEnquiry{
    rawMaterialGrades?: string[];
}

